
        require('./index.scss');
        'use strict';

var _jiaMeng = require('../../../model/service/jia-meng.js');

var _jiaMeng2 = _interopRequireDefault(_jiaMeng);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $ = window.$; /*
                   * @Author: finian
                   * @Date: 2021-01-25 10:33:18
                   * @LastEditors: your name
                   * @LastEditTime: 2021-01-28 10:19:12
                   */

var _ = window._;
var $$cookie = require('assets/util/cookie.js');
var $mod = $('.module-jiameng');
var $joinBtn = $('.join-btn');
var $modalWrapper = $('.module-modal');

$joinBtn.click(function () {
    $modalWrapper.show();
});

function isPlaceholer() {
    var input = document.createElement('input');
    return 'placeholder' in input;
}

if (!isPlaceholer()) {
    console.log('不兼容placeholder');
    $mod.find('.input-item').each(function (index, item) {
        if ($(item).val() == '') {
            $(item).css({
                'color': '#ccc'
            });
            $(item).val($(this).data('placeholder'));
        }
    });

    $mod.find('.input-item').focus(function () {
        $('#search').css({
            'color': '#ffffff'
        });
        if ($(this).val() == $(this).data('placeholder')) {
            $(this).val('');
        }
    });

    $mod.find('.input-item').blur(function () {
        if ($(this).val() == '') {
            $(this).val($(this).data('placeholder'));
            $('#search').css({
                'color': '#ccc'
            });
        } else {
            $('#search').css({
                'color': '#ffffff'
            });
        }
    });
}

var imgCount = 2;
var index = 1;
var intervalId = void 0;
var buttonSpan = $('.pointer')[0].children; // htmlCollection 集合
// 自动轮播功能 使用定时器
autoNextPage();
function autoNextPage() {
    intervalId = setInterval(function () {
        nextPage(true);
    }, 3000);
}
// 当鼠标移入 停止轮播
$('.container').mouseover(function () {
    console.log('hah');
    clearInterval(intervalId);
});
// 当鼠标移出，开始轮播
$('.container').mouseout(function () {
    autoNextPage();
});
// 点击下一页 上一页的功能
$('.left').click(function () {
    nextPage(true);
});
$('.right').click(function () {
    nextPage(false);
});
// 小圆点的相应功能 事件委托
// clickButtons();
// function clickButtons() {
//     let length = buttonSpan.length;
//     for (let i = 0; i < length; i++) {
//         buttonSpan[i].onclick = function () {
//             $(buttonSpan[index - 1]).removeClass('on');
//             if ($(this).attr('index') == 0) {
//                 index = 1;
//             } else {
//                 index = $(this).attr('index') - 1;
//             }
//             nextPage(true);
//         };
//     }
// }

function nextPage(next) {
    var targetLeft = 0;
    // 当前的圆点去掉on样式
    $(buttonSpan[index - 1]).removeClass('on');
    if (next) {
        // 往后走
        if (index == 2) {
            // 到最后一张，直接跳到第一张
            targetLeft = 0;
            index = 1;
        } else {
            index++;
            targetLeft = -1200 * (index - 1);
        }
    } else {
        // 往前走
        if (index == 1) {
            // 在第一张，直接跳到第五张
            index = 2;
            targetLeft = -1200 * (imgCount - 1);
        } else {
            index--;
            targetLeft = -1200 * (index - 1);
        }
    }
    $('.list').animate({ left: targetLeft + 'px' });
    // 更新后的圆点加上样式
    $(buttonSpan[index - 1]).addClass('on');
}

var joinName = $mod.find('[node-type="join-name"]');
var joinPhone = $mod.find('[node-type="join-phone"]');
var joinAgent = $mod.find('[node-type="join-agent"]');
var joinSubmit = $mod.find('[node-type="join-submit"]');
var preSubData = {};
function EmptyInput() {
    joinName.val('');
    joinPhone.val('');
    joinAgent.val('');
    $mod.find('[node-type="jm-nav-content"] input').removeClass('text-black');
}
var checkItems = {
    nameFn: function nameFn() {
        if (!/^[\u4e00-\u9fa5]+$/.test(joinName.val()) || joinName.val().length > 6 || joinName.val() === joinName.data('placeholder')) {
            joinName.siblings('[node-type="warn-tag"]').show().delay(2000).fadeOut('slow');
            return false;
        }
        return true;
    },
    phoneFn: function phoneFn() {
        var phonetest1 = /^(\+\d+)?1[3458]\d{9}$/.test(joinPhone.val());
        var phonetest2 = /^(\+\d+)?(\d{3,4}-?)?\d{7,8}$/.test(joinPhone.val());
        if (!(phonetest1 || phonetest2) || joinPhone.val() === joinPhone.data('placeholder')) {
            joinPhone.siblings('[node-type="warn-tag"]').show().delay(2000).fadeOut('slow');
            return false;
        }
        return true;
    },
    agentFn: function agentFn() {
        if (joinAgent.val().length > 20 || joinAgent.val().length <= 0 || joinAgent.val() === joinAgent.data('placeholder')) {
            joinAgent.siblings('[node-type="warn-tag"]').show().delay(2000).fadeOut('slow');
            return false;
        }
        return true;
    }
};
var submitFun = function submitFun() {
    if (checkItems.nameFn() && checkItems.phoneFn() && checkItems.agentFn()) {
        var submitData = {
            name: joinName.val(),
            phone: joinPhone.val(),
            agentCity: joinAgent.val()
        };
        // 重复提交同一内容判断
        if (preSubData.name == submitData.name && preSubData.phone == submitData.phone && preSubData.agentCity == submitData.agentCity) {
            $mod.find('[node-type="jm-text"]').text('请勿重复提交！');
            $mod.find('[node-type="jm-return"]').show();
            return;
        } else {
            preSubData.name = submitData.name;
            preSubData.phone = submitData.phone;
            preSubData.agentCity = submitData.agentCity;
        }
        // 每天提交最多三次判断
        var countInfo = parseInt($$cookie.getCookie('jiamengCount'));
        if (countInfo) {
            if (countInfo <= 3) {
                $$cookie.setCookie('jiamengCount', countInfo + 1);
            } else {
                EmptyInput();
                $mod.find('[node-type="jm-text"]').text('每天最多能提交三次！');
                $mod.find('[node-type="jm-return"]').show();
            }
        } else {
            $$cookie.setCookie('jiamengCount', 1);
        }
        console.log(submitData, 'submitData');
        _jiaMeng2['default'].jiaMengSubmit(submitData).then(function (res) {
            if (res && res.code == 200) {
                EmptyInput();
                $mod.find('[node-type="jm-text"]').text('信息提交成功！我们的工作人员会尽快联系你，敬请期待！');
            } else {
                $mod.find('[node-type="jm-text"]').text(res.msg);
            }
            $mod.find('[node-type="jm-return"]').show();
        });
    }
};
var submitFn = _.throttle(submitFun, 200);
joinSubmit.click(function () {
    submitFn();
});
$mod.find('[node-type="jm-close"]').click(function () {
    $mod.find('[node-type="jm-return"]').hide();
});;
    


// WEBPACK FOOTER //
// ./src/module/jiameng/content/index.js